import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { captureAttribution } from '@/utils/attribution'
import LoginView from '../views/LoginView.vue'
import RegisterView from '../views/RegisterView.vue'
import ForgotPasswordView from '../views/ForgotPasswordView.vue'

import ProductsView from '../views/ProductsView.vue'
import ProductDetailView from '../views/ProductDetailView.vue'
import ApplicationsView from '../views/ApplicationsView.vue'
import ApplicationDetailView from '../views/ApplicationDetailView.vue'
import AboutUsView from '../views/AboutUsView.vue'
import TermsOfServiceView from '../views/TermsOfServiceView.vue'
import PrivacyPolicyView from '../views/PrivacyPolicyView.vue'
import AccountSettingsView from '../views/AccountSettingsView.vue'

import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterView
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: ForgotPasswordView
  },
  // 产品浏览（公开）
  {
    path: '/products',
    name: 'products',
    component: ProductsView
  },
  {
    path: '/products/:id',
    name: 'product-detail',
    component: ProductDetailView,
    props: true
  },
  {
    path: '/applications',
    name: 'applications',
    component: ApplicationsView
  },
  {
    path: '/applications/:id',
    name: 'application-detail',
    component: ApplicationDetailView,
    props: true
  },
  // 招募落地页（公开）
  {
    path: '/join',
    name: 'join',
    component: () => import('../views/JoinView.vue')
  },
  {
    path: '/about-us',
    name: 'about-us',
    component: AboutUsView
  },
  // 样品申请（需登录）
  {
    path: '/sample/apply',
    name: 'sample-apply',
    component: () => import('../views/SampleApplyView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/sample/list',
    name: 'sample-list',
    component: () => import('../views/SampleListView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/sample/detail/:id',
    name: 'sample-detail',
    component: () => import('../views/SampleDetailView.vue'),
    props: true,
    meta: { requiresAuth: true }
  },
  // 佣金计算器（公开）
  {
    path: '/commission/calc',
    name: 'commission-calc',
    component: () => import('../views/CommissionCalcView.vue')
  },
  // 我的收益（需登录）
  {
    path: '/earnings',
    name: 'earnings',
    component: () => import('../views/EarningsView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/earnings/deals',
    name: 'earnings-deals',
    component: () => import('../views/DealsView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/invite',
    name: 'invite-center',
    component: () => import('../views/InviteCenterView.vue'),
    meta: { requiresAuth: true }
  },
  // 我的客户（需登录）
  {
    path: '/customers',
    name: 'customers',
    component: () => import('../views/CustomersView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/addresses',
    name: 'addresses',
    component: () => import('../views/AddressBookView.vue'),
    meta: { requiresAuth: true }
  },
  // 法律页面
  {
    path: '/terms',
    name: 'terms',
    component: TermsOfServiceView
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: PrivacyPolicyView
  },
  // 账号设置（需登录）
  {
    path: '/account-settings',
    name: 'account-settings',
    component: AccountSettingsView,
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
})

router.beforeEach((to, from, next) => {
  captureAttribution(to.query)

  if (to.meta.requiresAuth) {
    try {
      const authStore = useAuthStore()
      if (!authStore.isLoggedIn) {
        next({
          path: '/login',
          query: { redirect: to.fullPath }
        })
      } else {
        next()
      }
    } catch (error) {
      console.warn('Auth store not available during navigation guard:', error)
      next()
    }
  } else {
    next()
  }
})

export default router
